import angular from 'angular';
import 'satellizer';
import 'restangular';
import Resources from '../resources/resources';

export default angular.module('app.configs.api', [
  Resources.name,
  'satellizer',
  'restangular'
])
.constant('api', {
  baseURL: ''
  // baseURL: 'http://localhost:8080' /* for external domain API */
})
.config(function ($authProvider, api) {
  $authProvider.baseUrl = api.baseURL;
  $authProvider.loginUrl = '/oauth/v2/token';
  $authProvider.logoutUrl = '/oauth/token/revoke';
  $authProvider.tokenName = 'access_token';
})
.config(function (RestangularProvider, api) {
  RestangularProvider.setDefaultHeaders({'Content-Type': 'application/json'});
  RestangularProvider.setBaseUrl(`${api.baseURL}/api/v1`);
  RestangularProvider.addFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
    return {
      httpConfig: httpConfig
    };
  });
})
.run(function ($auth, $state, Restangular) {
  Restangular.setErrorInterceptor(function (response) {
    let status401 = response.status == 401;
    let usersMeStatus500 = response.status == 500 && response.config.url.match(/\/users\/me$/);

    if (status401 || usersMeStatus500) {
      $auth.logout();
      $state.go('login');
      return false;
    } else {
      return true;
    }
  });

  Restangular.addFullRequestInterceptor(function (element, operation, what, url, headers, params, httpConfig) {
    let req = {};
    let fileUploadPattern = /upload$/;
    let result = fileUploadPattern.test(url);
    if (fileUploadPattern.test(url)) {
      req = {
        element: element,
        params: params,
        headers: _.assign(headers, {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: 'Bearer ' + $auth.getToken(),
          'Requested-From-Component': 'pepapi-frontend',
          'Content-Type': undefined
        }),
        httpConfig: httpConfig
      };
    } else {
      req = {
        element: element,
        params: params,
        headers: _.assign(headers, {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: 'Bearer ' + $auth.getToken(),
          'Requested-From-Component': 'pepapi-frontend',
        }),
        httpConfig: httpConfig
      };
    }

    return req;
  });
})
.service('acquisitionSourcesOptions', function ($filter) {
  return [
    'facebook',
    'google',
    'organic',
  ].map(option => ({value: option, name: $filter('translate')(option)}));
})
.service('genresOptions', function () {
  return [
    {value: 'action', name: 'Action'},
    {value: 'adventure', name: 'Adventure'},
    {value: 'arcade', name: 'Arcade'},
    {value: 'board', name: 'Board'},
    {value: 'card', name: 'Card'},
    {value: 'casino', name: 'Casino'},
    {value: 'casual', name: 'Casual'},
    {value: 'dice', name: 'Dice'},
    {value: 'educational', name: 'Educational'},
    {value: 'family', name: 'Family'},
    {value: 'music', name: 'Music'},
    {value: 'puzzle', name: 'Puzzle'},
    {value: 'racing', name: 'Racing'},
    {value: 'role_playing', name: 'Role Playing'},
    {value: 'simulation', name: 'Simulation'},
    {value: 'sports', name: 'Sports'},
    {value: 'strategy', name: 'Strategy'},
    {value: 'trivia', name: 'Trivia'},
    {value: 'word', name: 'Word'}
  ]
})
.service('playerExploreGenresOptions', function () {
  return [
    {value: 'Books', name: 'Books'},
    {value: 'Business', name: 'Business'},
    {value: 'Catalogs', name: 'Catalogs'},
    {value: 'Education', name: 'Education'},
    {value: 'Entertainment', name: 'Entertainment'},
    {value: 'Finance', name: 'Finance'},
    {value: 'Food & Drink', name: 'Food & Drink'},
    {value: 'Games', name: 'Games'},
    {value: 'Action', name: 'Action'},
    {value: 'Adventure', name: 'Adventure'},
    {value: 'Arcade', name: 'Arcade'},
    {value: 'Board', name: 'Board'},
    {value: 'Card', name: 'Card'},
    {value: 'Casino', name: 'Casino'},
    {value: 'Dice', name: 'Dice'},
    {value: 'Educational', name: 'Educational'},
    {value: 'Family', name: 'Family'},
    {value: 'Kids', name: 'Kids'},
    {value: 'Music', name: 'Music'},
    {value: 'Puzzle', name: 'Puzzle'},
    {value: 'Racing', name: 'Racing'},
    {value: 'Role Playing', name: 'Role Playing'},
    {value: 'Simulation', name: 'Simulation'},
    {value: 'Sports', name: 'Sports'},
    {value: 'Strategy', name: 'Strategy'},
    {value: 'Trivia', name: 'Trivia'},
    {value: 'Word', name: 'Word'},
    {value: 'Health & Fitness', name: 'Health & Fitness'},
    {value: 'Lifestyle', name: 'Lifestyle'},
    {value: 'Medical', name: 'Medical'},
    {value: 'Music', name: 'Music'},
    {value: 'Navigation', name: 'Navigation'},
    {value: 'News', name: 'News'},
    {value: 'Photo & Video', name: 'Photo & Video'},
    {value: 'Productivity', name: 'Productivity'},
    {value: 'Reference', name: 'Reference'},
    {value: 'Social Networking', name: 'Social Networking'},
    {value: 'Sports', name: 'Sports'},
    {value: 'Travel', name: 'Travel'},
    {value: 'Utilities', name: 'Utilities'},
    {value: 'Weather', name: 'Weather'}
  ]
})
.service('iabCategoriesOptions', function () {
  return [
    {value: 'IAB1', name: 'Arts & Entertainment'},
    {value: 'IAB1-1', name: 'Books & Literature'},
    {value: 'IAB1-2', name: 'Celebrity Fan/Gossip'},
    {value: 'IAB1-3', name: 'Fine Art'},
    {value: 'IAB1-4', name: 'Humor'},
    {value: 'IAB1-5', name: 'Movies'},
    {value: 'IAB1-6', name: 'Music'},
    {value: 'IAB1-7', name: 'Television'},
    {value: 'IAB2', name: 'Automotive'},
    {value: 'IAB2-1', name: 'Auto Parts'},
    {value: 'IAB2-2', name: 'Auto Repair'},
    {value: 'IAB2-3', name: 'Buying/Selling Cars'},
    {value: 'IAB2-4', name: 'Car Culture'},
    {value: 'IAB2-5', name: 'Certified Pre-Owned'},
    {value: 'IAB2-6', name: 'Convertible'},
    {value: 'IAB2-7', name: 'Coupe'},
    {value: 'IAB2-8', name: 'Crossover'},
    {value: 'IAB2-9', name: 'Diesel'},
    {value: 'IAB2-10', name: 'Electric Vehicle'},
    {value: 'IAB2-11', name: 'Hatchback'},
    {value: 'IAB2-12', name: 'Hybrid'},
    {value: 'IAB2-13', name: 'Luxury'},
    {value: 'IAB2-14', name: 'MiniVan'},
    {value: 'IAB2-15', name: 'Mororcycles'},
    {value: 'IAB2-16', name: 'Off-Road Vehicles'},
    {value: 'IAB2-17', name: 'Performance Vehicles'},
    {value: 'IAB2-18', name: 'Pickup'},
    {value: 'IAB2-19', name: 'Road-Side Assistance'},
    {value: 'IAB2-20', name: 'Sedan'},
    {value: 'IAB2-21', name: 'Trucks & Accessories'},
    {value: 'IAB2-22', name: 'Vintage Cars'},
    {value: 'IAB2-23', name: 'Wagon'},
    {value: 'IAB3', name: 'Business'},
    {value: 'IAB3-1', name: 'Advertising'},
    {value: 'IAB3-2', name: 'Agriculture'},
    {value: 'IAB3-3', name: 'Biotech/Biomedical'},
    {value: 'IAB3-4', name: 'Business Software'},
    {value: 'IAB3-5', name: 'Construction'},
    {value: 'IAB3-6', name: 'Forestry'},
    {value: 'IAB3-7', name: 'Government'},
    {value: 'IAB3-8', name: 'Green Solutions'},
    {value: 'IAB3-9', name: 'Human Resources'},
    {value: 'IAB3-10', name: 'Logistics'},
    {value: 'IAB3-11', name: 'Marketing'},
    {value: 'IAB3-12', name: 'Metals'},
    {value: 'IAB4', name: 'Careers'},
    {value: 'IAB4-1', name: 'Career Planning'},
    {value: 'IAB4-2', name: 'College'},
    {value: 'IAB4-3', name: 'Financial Aid'},
    {value: 'IAB4-4', name: 'Job Fairs'},
    {value: 'IAB4-5', name: 'Job Search'},
    {value: 'IAB4-6', name: 'Resume Writing/Advice'},
    {value: 'IAB4-7', name: 'Nursing'},
    {value: 'IAB4-8', name: 'Scholarships'},
    {value: 'IAB4-9', name: 'Telecommuting'},
    {value: 'IAB4-10', name: 'U.S. Military'},
    {value: 'IAB4-11', name: 'Career Advice'},
    {value: 'IAB5', name: 'Education'},
    {value: 'IAB5-1', name: '7-12 Education'},
    {value: 'IAB5-2', name: 'Adult Education'},
    {value: 'IAB5-3', name: 'Art History'},
    {value: 'IAB5-4', name: 'Colledge Administration'},
    {value: 'IAB5-5', name: 'College Life'},
    {value: 'IAB5-6', name: 'Distance Learning'},
    {value: 'IAB5-7', name: 'English as a 2nd Language'},
    {value: 'IAB5-8', name: 'Language Learning'},
    {value: 'IAB5-9', name: 'Graduate School'},
    {value: 'IAB5-10', name: 'Homeschooling'},
    {value: 'IAB5-11', name: 'Homework/Study Tips'},
    {value: 'IAB5-12', name: 'K-6 Educators'},
    {value: 'IAB5-13', name: 'Private School'},
    {value: 'IAB5-14', name: 'Special Education'},
    {value: 'IAB5-15', name: 'Studying Business'},
    {value: 'IAB6', name: 'Family & Parenting'},
    {value: 'IAB6-1', name: 'Adoption'},
    {value: 'IAB6-2', name: 'Babies & Toddlers'},
    {value: 'IAB6-3', name: 'Daycare/Pre School'},
    {value: 'IAB6-4', name: 'Family Internet'},
    {value: 'IAB6-5', name: 'Parenting - K-6 Kids'},
    {value: 'IAB6-6', name: 'Parenting teens'},
    {value: 'IAB6-7', name: 'Pregnancy'},
    {value: 'IAB6-8', name: 'Special Needs Kids'},
    {value: 'IAB6-9', name: 'Eldercare'},
    {value: 'IAB7', name: 'Health & Fitness'},
    {value: 'IAB7-1', name: 'Exercise'},
    {value: 'IAB7-2', name: 'A.D.D.'},
    {value: 'IAB7-3', name: 'AIDS/HIV'},
    {value: 'IAB7-4', name: 'Allergies'},
    {value: 'IAB7-5', name: 'Alternative Medicine'},
    {value: 'IAB7-6', name: 'Arthritis'},
    {value: 'IAB7-7', name: 'Asthma'},
    {value: 'IAB7-8', name: 'Autism/PDD'},
    {value: 'IAB7-9', name: 'Bipolar Disorder'},
    {value: 'IAB7-10', name: 'Brain Tumor'},
    {value: 'IAB7-11', name: 'Cancer'},
    {value: 'IAB7-12', name: 'Cholesterol'},
    {value: 'IAB7-13', name: 'Chronic Fatigue Syndrome'},
    {value: 'IAB7-14', name: 'Chronic Pain'},
    {value: 'IAB7-15', name: 'Cold & Flu'},
    {value: 'IAB7-16', name: 'Deafness'},
    {value: 'IAB7-17', name: 'Dental Care'},
    {value: 'IAB7-18', name: 'Depression'},
    {value: 'IAB7-19', name: 'Dermatology'},
    {value: 'IAB7-20', name: 'Diabetes'},
    {value: 'IAB7-21', name: 'Epilepsy'},
    {value: 'IAB7-22', name: 'GERD/Acid Reflux'},
    {value: 'IAB7-23', name: 'Headaches/Migraines'},
    {value: 'IAB7-24', name: 'Heart Disease'},
    {value: 'IAB7-25', name: 'Herbs for Health'},
    {value: 'IAB7-26', name: 'Holistic Healing'},
    {value: 'IAB7-27', name: 'IBS/Crohn\'s Disease'},
    {value: 'IAB7-28', name: 'Incest/Abuse Support'},
    {value: 'IAB7-29', name: 'Incontinence'},
    {value: 'IAB7-30', name: 'Infertility'},
    {value: 'IAB7-31', name: 'Men\'s Health'},
    {value: 'IAB7-32', name: 'Nutrition'},
    {value: 'IAB7-33', name: 'Orthopedics'},
    {value: 'IAB7-34', name: 'Panic/Anxiety Disorders'},
    {value: 'IAB7-35', name: 'Pediatrics'},
    {value: 'IAB7-36', name: 'Physical Therapy'},
    {value: 'IAB7-37', name: 'Psychology/Psychiatry'},
    {value: 'IAB7-38', name: 'Senor Health'},
    {value: 'IAB7-39', name: 'Sexuality'},
    {value: 'IAB7-40', name: 'Sleep Disorders'},
    {value: 'IAB7-41', name: 'Smoking Cessation'},
    {value: 'IAB7-42', name: 'Substance Abuse'},
    {value: 'IAB7-43', name: 'Thyroid Disease'},
    {value: 'IAB7-44', name: 'Weight Loss'},
    {value: 'IAB7-45', name: 'Women\'s Health'},
    {value: 'IAB8', name: 'Food & Drink'},
    {value: 'IAB8-1', name: 'American Cuisine'},
    {value: 'IAB8-2', name: 'Barbecues & Grilling'},
    {value: 'IAB8-3', name: 'Cajun/Creole'},
    {value: 'IAB8-4', name: 'Chinese Cuisine'},
    {value: 'IAB8-5', name: 'Cocktails/Beer'},
    {value: 'IAB8-6', name: 'Coffee/Tea'},
    {value: 'IAB8-7', name: 'Cuisine-Specific'},
    {value: 'IAB8-8', name: 'Desserts & Baking'},
    {value: 'IAB8-9', name: 'Dining Out'},
    {value: 'IAB8-10', name: 'Food Allergies'},
    {value: 'IAB8-11', name: 'French Cuisine'},
    {value: 'IAB8-12', name: 'Health/Lowfat Cooking'},
    {value: 'IAB8-13', name: 'Italian Cuisine'},
    {value: 'IAB8-14', name: 'Japanese Cuisine'},
    {value: 'IAB8-15', name: 'Mexican Cuisine'},
    {value: 'IAB8-16', name: 'Vegan'},
    {value: 'IAB8-17', name: 'Vegetarian'},
    {value: 'IAB8-18', name: 'Wine'},
    {value: 'IAB9', name: 'Hobbies & Interests'},
    {value: 'IAB9-1', name: 'Art/Technology'},
    {value: 'IAB9-2', name: 'Arts & Crafts'},
    {value: 'IAB9-3', name: 'Beadwork'},
    {value: 'IAB9-4', name: 'Birdwatching'},
    {value: 'IAB9-5', name: 'Board Games/Puzzles'},
    {value: 'IAB9-6', name: 'Candle & Soap Making'},
    {value: 'IAB9-7', name: 'Card Games'},
    {value: 'IAB9-8', name: 'Chess'},
    {value: 'IAB9-9', name: 'Cigars'},
    {value: 'IAB9-10', name: 'Collecting'},
    {value: 'IAB9-11', name: 'Comic Books'},
    {value: 'IAB9-12', name: 'Drawing/Sketching'},
    {value: 'IAB9-13', name: 'Freelance Writing'},
    {value: 'IAB9-14', name: 'Genealogy'},
    {value: 'IAB9-15', name: 'Getting Published'},
    {value: 'IAB9-16', name: 'Guitar'},
    {value: 'IAB9-17', name: 'Home Recording'},
    {value: 'IAB9-18', name: 'Investors & Patents'},
    {value: 'IAB9-19', name: 'Jewelry Making'},
    {value: 'IAB9-20', name: 'Magic & Illusion'},
    {value: 'IAB9-21', name: 'Needlework'},
    {value: 'IAB9-22', name: 'Painting'},
    {value: 'IAB9-23', name: 'Photography'},
    {value: 'IAB9-24', name: 'Radio'},
    {value: 'IAB9-25', name: 'Roleplaying Games'},
    {value: 'IAB9-26', name: 'Sci-Fi & Fantasy'},
    {value: 'IAB9-27', name: 'Scrapbooking'},
    {value: 'IAB9-28', name: 'Screenwriting'},
    {value: 'IAB9-29', name: 'Stamps & Coins'},
    {value: 'IAB9-30', name: 'Video & Computer Games'},
    {value: 'IAB9-31', name: 'Woodworking'},
    {value: 'IAB10', name: 'Home & Garden'},
    {value: 'IAB10-1', name: 'Appliances'},
    {value: 'IAB10-2', name: 'Entertaining'},
    {value: 'IAB10-3', name: 'Environmental Safety'},
    {value: 'IAB10-4', name: 'Gardening'},
    {value: 'IAB10-5', name: 'Home Repair'},
    {value: 'IAB10-6', name: 'Home Theater'},
    {value: 'IAB10-7', name: 'Interior Decorating'},
    {value: 'IAB10-8', name: 'Landscaping'},
    {value: 'IAB10-9', name: 'Remodeling & Construction'},
    {value: 'IAB11', name: 'Law, Gov\'t & Politics'},
    {value: 'IAB11-1', name: 'Immigration'},
    {value: 'IAB11-2', name: 'Legal Issues'},
    {value: 'IAB11-3', name: 'U.S. Government Resources'},
    {value: 'IAB11-4', name: 'Politics'},
    {value: 'IAB11-5', name: 'Commentary'},
    {value: 'IAB12', name: 'News'},
    {value: 'IAB12-1', name: 'International News'},
    {value: 'IAB12-2', name: 'National News'},
    {value: 'IAB12-3', name: 'Local News'},
    {value: 'IAB13', name: 'Personal Finance'},
    {value: 'IAB13-1', name: 'Beginning Investing'},
    {value: 'IAB13-2', name: 'Credit/Debt & Loans'},
    {value: 'IAB13-3', name: 'Financial News'},
    {value: 'IAB13-4', name: 'Financial Planning'},
    {value: 'IAB13-5', name: 'Hedge Fund'},
    {value: 'IAB13-6', name: 'Insurance'},
    {value: 'IAB13-7', name: 'Investing'},
    {value: 'IAB13-8', name: 'Mutual Funds'},
    {value: 'IAB13-9', name: 'Options'},
    {value: 'IAB13-10', name: 'Retirement Planning'},
    {value: 'IAB13-11', name: 'Stocks'},
    {value: 'IAB13-12', name: 'Tax Planning'},
    {value: 'IAB14', name: 'Society'},
    {value: 'IAB14-1', name: 'Dating'},
    {value: 'IAB14-2', name: 'Divorce Support'},
    {value: 'IAB14-3', name: 'Gay Life'},
    {value: 'IAB14-4', name: 'Marriage'},
    {value: 'IAB14-5', name: 'Senior Living'},
    {value: 'IAB14-6', name: 'Teens'},
    {value: 'IAB14-7', name: 'Weddings'},
    {value: 'IAB14-8', name: 'Ethnic Specific'},
    {value: 'IAB15', name: 'Science'},
    {value: 'IAB15-1', name: 'Astrology'},
    {value: 'IAB15-2', name: 'Biology'},
    {value: 'IAB15-3', name: 'Chemistry'},
    {value: 'IAB15-4', name: 'Geology'},
    {value: 'IAB15-5', name: 'Paranormal Phenomena'},
    {value: 'IAB15-6', name: 'Physics'},
    {value: 'IAB15-7', name: 'Space/Astronomy'},
    {value: 'IAB15-8', name: 'Geography'},
    {value: 'IAB15-9', name: 'Botany'},
    {value: 'IAB15-10', name: 'Weather'},
    {value: 'IAB16', name: 'Pets'},
    {value: 'IAB16-1', name: 'Aquariums'},
    {value: 'IAB16-2', name: 'Birds'},
    {value: 'IAB16-3', name: 'Cats'},
    {value: 'IAB16-4', name: 'Dogs'},
    {value: 'IAB16-5', name: 'Large Animals'},
    {value: 'IAB16-6', name: 'Reptiles'},
    {value: 'IAB16-7', name: 'Veterinary Medicine'},
    {value: 'IAB17', name: 'Sports'},
    {value: 'IAB17-1', name: 'Auto Racing'},
    {value: 'IAB17-2', name: 'Baseball'},
    {value: 'IAB17-3', name: 'Bicycling'},
    {value: 'IAB17-4', name: 'Bodybuilding'},
    {value: 'IAB17-5', name: 'Boxing'},
    {value: 'IAB17-6', name: 'Canoeing/Kayaking'},
    {value: 'IAB17-7', name: 'Cheerleading'},
    {value: 'IAB17-8', name: 'Climbing'},
    {value: 'IAB17-9', name: 'Cricket'},
    {value: 'IAB17-10', name: 'Figure Skating'},
    {value: 'IAB17-11', name: 'Fly Fishing'},
    {value: 'IAB17-12', name: 'Football'},
    {value: 'IAB17-13', name: 'Freshwater Fishing'},
    {value: 'IAB17-14', name: 'Game & Fish'},
    {value: 'IAB17-15', name: 'Golf'},
    {value: 'IAB17-16', name: 'Horse Racing'},
    {value: 'IAB17-17', name: 'Horses'},
    {value: 'IAB17-18', name: 'Hunting/Shooting'},
    {value: 'IAB17-19', name: 'Inline Skating'},
    {value: 'IAB17-20', name: 'Martial Arts'},
    {value: 'IAB17-21', name: 'Mountain Biking'},
    {value: 'IAB17-22', name: 'NASCAR Racing'},
    {value: 'IAB17-23', name: 'Olympics'},
    {value: 'IAB17-24', name: 'Paintball'},
    {value: 'IAB17-25', name: 'Power & Motorcycles'},
    {value: 'IAB17-26', name: 'Pro Basketball'},
    {value: 'IAB17-27', name: 'Pro Ice Hockey'},
    {value: 'IAB17-28', name: 'Rodeo'},
    {value: 'IAB17-29', name: 'Rugby'},
    {value: 'IAB17-30', name: 'Running/Jogging'},
    {value: 'IAB17-31', name: 'Sailing'},
    {value: 'IAB17-32', name: 'Saltwater Fishing'},
    {value: 'IAB17-33', name: 'Scuba Diving'},
    {value: 'IAB17-34', name: 'Skateboarding'},
    {value: 'IAB17-42', name: 'Walking'},
    {value: 'IAB17-43', name: 'Waterski/Wakeboard'},
    {value: 'IAB17-44', name: 'World Soccer'},
    {value: 'IAB18', name: 'Style & Fashion'},
    {value: 'IAB18-1', name: 'Beauty'},
    {value: 'IAB18-2', name: 'Body Art'},
    {value: 'IAB18-3', name: 'Fashion'},
    {value: 'IAB18-4', name: 'Jewelry'},
    {value: 'IAB18-5', name: 'Clothing'},
    {value: 'IAB18-6', name: 'Accessories'},
    {value: 'IAB19', name: 'Technology & Computing'},
    {value: 'IAB19-1', name: '3-D Graphics'},
    {value: 'IAB19-2', name: 'Animation'},
    {value: 'IAB19-3', name: 'Antivirus Software'},
    {value: 'IAB19-4', name: 'C/C++'},
    {value: 'IAB19-5', name: 'Cameras & Camcorders'},
    {value: 'IAB19-6', name: 'Cell Phones'},
    {value: 'IAB19-7', name: 'Computer Certification'},
    {value: 'IAB19-8', name: 'Computer Networking'},
    {value: 'IAB19-9', name: 'Computer Peripherals'},
    {value: 'IAB19-10', name: 'Computer Reviews'},
    {value: 'IAB19-11', name: 'Data Centers'},
    {value: 'IAB19-12', name: 'Databases'},
    {value: 'IAB19-13', name: 'Desktop Publishing'},
    {value: 'IAB19-14', name: 'Desktop Video'},
    {value: 'IAB19-15', name: 'Email'},
    {value: 'IAB19-16', name: 'Graphics Software'},
    {value: 'IAB19-17', name: 'Home Video/DVD'},
    {value: 'IAB19-18', name: 'Internet Technology'},
    {value: 'IAB19-19', name: 'Java'},
    {value: 'IAB19-20', name: 'JavaScript'},
    {value: 'IAB19-21', name: 'Mac Support'},
    {value: 'IAB19-22', name: 'MP3/MIDI'},
    {value: 'IAB19-23', name: 'Net Conferencing'},
    {value: 'IAB19-24', name: 'Net for Beginners'},
    {value: 'IAB19-25', name: 'Network Security'},
    {value: 'IAB19-26', name: 'Palmtops/PDAs'},
    {value: 'IAB19-27', name: 'PC Support'},
    {value: 'IAB19-28', name: 'Portable'},
    {value: 'IAB19-29', name: 'Entertainment'},
    {value: 'IAB19-30', name: 'Shareware/Freeware'},
    {value: 'IAB19-31', name: 'Unix'},
    {value: 'IAB19-32', name: 'Visual Basic'},
    {value: 'IAB19-33', name: 'Web Clip Art'},
    {value: 'IAB19-34', name: 'Web Design/HTML'},
    {value: 'IAB19-35', name: 'Web Search'},
    {value: 'IAB19-36', name: 'Windows'},
    {value: 'IAB20', name: 'Travel'},
    {value: 'IAB20-1', name: 'Adventure Travel'},
    {value: 'IAB20-2', name: 'Africa'},
    {value: 'IAB20-3', name: 'Air Travel'},
    {value: 'IAB20-4', name: 'Australia & New Zealand'},
    {value: 'IAB20-5', name: 'Bed & Breakfasts'},
    {value: 'IAB20-6', name: 'Budget Travel'},
    {value: 'IAB20-7', name: 'Business Travel'},
    {value: 'IAB20-8', name: 'By US Locale'},
    {value: 'IAB20-9', name: 'Camping'},
    {value: 'IAB20-10', name: 'Canada'},
    {value: 'IAB20-11', name: 'Caribbean'},
    {value: 'IAB20-12', name: 'Cruises'},
    {value: 'IAB20-13', name: 'Eastern Europe'},
    {value: 'IAB20-14', name: 'Europe'},
    {value: 'IAB20-15', name: 'France'},
    {value: 'IAB20-16', name: 'Greece'},
    {value: 'IAB20-17', name: 'Honeymoons/Getaways'},
    {value: 'IAB20-18', name: 'Hotels'},
    {value: 'IAB20-19', name: 'Italy'},
    {value: 'IAB20-20', name: 'Japan'},
    {value: 'IAB20-21', name: 'Mexico & Central America'},
    {value: 'IAB20-22', name: 'National Parks'},
    {value: 'IAB20-23', name: 'South America'},
    {value: 'IAB20-24', name: 'Spas'},
    {value: 'IAB20-25', name: 'Theme Parks'},
    {value: 'IAB20-26', name: 'Traveling with Kids'},
    {value: 'IAB20-27', name: 'United Kingdom'},
    {value: 'IAB21', name: 'Real Estate'},
    {value: 'IAB21-1', name: 'Apartments'},
    {value: 'IAB21-2', name: 'Architects'},
    {value: 'IAB21-3', name: 'Buying/Selling Homes'},
    {value: 'IAB22', name: 'Shopping'},
    {value: 'IAB22-1', name: 'Contests & Freebies'},
    {value: 'IAB22-2', name: 'Couponing'},
    {value: 'IAB22-3', name: 'Comparison'},
    {value: 'IAB22-4', name: 'Engines'},
    {value: 'IAB23', name: 'Religion & Spirituality'},
    {value: 'IAB23-1', name: 'Alternative Religions'},
    {value: 'IAB23-2', name: 'Atheism/Agnosticism'},
    {value: 'IAB23-3', name: 'Buddhism'},
    {value: 'IAB23-4', name: 'Catholicism'},
    {value: 'IAB23-5', name: 'Christianity'},
    {value: 'IAB23-6', name: 'Hinduism'},
    {value: 'IAB23-7', name: 'Islam'},
    {value: 'IAB23-8', name: 'Judaism'},
    {value: 'IAB23-9', name: 'Latter-Day Saints'},
    {value: 'IAB23-10', name: 'Pagan/Wiccan'},
    {value: 'IAB24', name: 'Uncategorized'},
    {value: 'IAB25', name: 'Non-Standard Content'},
    {value: 'IAB25-1', name: 'Unmoderated UGC'},
    {value: 'IAB25-2', name: 'Extreme Graphic/Explicit Violence'},
    {value: 'IAB25-3', name: 'Pornography'},
    {value: 'IAB25-4', name: 'Profane Content'},
    {value: 'IAB25-5', name: 'Hate Content'},
    {value: 'IAB25-6', name: 'Under Construction'},
    {value: 'IAB25-7', name: 'Incentivized'},
    {value: 'IAB26', name: 'Illegal Content'},
    {value: 'IAB26-1', name: 'Illegal Content'},
    {value: 'IAB26-2', name: 'Warez'},
    {value: 'IAB26-3', name: 'Spyware/Malware'},
    {value: 'IAB26-4', name: 'CopyrightInfringement'},
    {value: 'IAB17-35', name: 'Skiing'},
    {value: 'IAB17-36', name: 'Snowboarding'},
    {value: 'IAB17-37', name: 'Surfing/Bodyboarding'},
    {value: 'IAB17-38', name: 'Swimming'},
    {value: 'IAB17-39', name: 'Table Tennis/Ping-Pong'},
    {value: 'IAB17-40', name: 'Tennis'},
    {value: 'IAB17-41', name: 'Volleyball'}
  ]
})
.service('paymentTypesOptions', function ($filter) {
  return [
    'cash',
    'coins',
  ].map(option => ({value: option, name: $filter('translate')(option)}));
})
.service('platformsOptions', function () {
  return [
    {value: 'Android', name: 'Android', icon: 'platform-android'},
    {value: 'iOS', name: 'iOS', icon: 'platform-ios'},
  ]
})
.service('deviceOsOptions', function () {
  return [
    {value: 'iOS', name: 'iOS', icon: 'platform-ios'},
    {value: 'Android', name: 'Android', icon: 'platform-android'},
    {value: 'Windows', name: 'Windows', icon: 'platform-windows'},
    {value: 'Mac', name: 'Mac', icon: 'platform-ios'},
    {value: 'Linux', name: 'Linux', icon: 'platform-desktop'},
    {value: 'Other', name: 'Other', icon: 'platform-desktop'},
  ]
})
.service('deviceTypeOptions', function () {
  return [
    {value: 'Desktop', name: 'Desktop', icon: 'platform-desktop'},
    {value: 'Tablet', name: 'Tablet', icon: 'platform-android'},
    {value: 'Smartphone', name: 'Smartphone', icon: 'platform-ios'},
    {value: 'Other', name: 'Other', icon: 'platform-desktop'},
  ]
})
.service('stopReasonsOptions', function () {
  return [
    {value: 'BUDGET_CAPPED', name: 'stop_reason_budget_capped'},
    {value: 'BUDGET_ENDED', name: 'stop_reason_budget_ended'},
    {value: 'PERFORMANCE', name: 'stop_reason_performance'},
    {value: 'CREATIVE_REFRESH', name: 'stop_reason_creative_refresh'},
    {value: 'FLIGHT_ENDED', name: 'stop_reason_flight_ended'},
    {value: 'SEASONALITY', name: 'stop_reason_seasonality'},
    {value: 'ADVERTISER_REQUEST', name: 'stop_reason_advertiser_request'},
    {value: 'TECHNICAL_ISSUE', name: 'stop_reason_technical_issue'},
    {value: 'INTERNAL_TEST', name: 'stop_reason_internal_test'},
  ]
})
.service('progressOptions', function ($filter) {
  return [
    'Level 1',
    'Level 2',
    'Level 3',
    'Level 4',
    'Level 5'
  ].map(option => ({value: option, name: option}));
})
.service('rolesOptions', function () {
  return [
    {value: 'APP_DEVELOPER', name: 'APP_DEVELOPER'},
    {value: 'AGENCY', name: 'AGENCY'},
    {value: 'ADMIN_AGENCY', name: 'ADMIN_AGENCY'},
    {value: 'GD_ACCOUNT_MANAGER', name: 'GD_ACCOUNT_MANAGER'},
    {value: 'GG_ACCOUNT_MANAGER', name: 'GG_ACCOUNT_MANAGER'},
    {value: 'ADMIN', name: 'ADMIN'},
    {value: 'SELLER_ONLY', name: 'SELLER_ONLY'},
    {value: 'BUYER_ONLY', name: 'BUYER_ONLY'},
    {value: 'OPERATION_MANAGER', name: 'OPERATION_MANAGER'},
  ]
})
.service('currencyOptions', function() {
  return [
    'USD',
  ].map(option => ({value: option, name: option}));
})
.service('yesNoOptions', function() {
  return [
    {name: 'yes', value: true},
    {name: 'no', value: false}
  ];
})



/** WEBPACK FOOTER **
 ** ./src/configs/api.config.js
 **/